import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { NoDataPlaceHolderTableRow } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { RightArrow } from 'src/components/SvgIcons/SvgIcons';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { BEACON_TABS, BEACON_SUBTABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';

interface LibraryEmptyStateProps {
  searchQuery?: string;
}

export const LibraryEmptyState: React.FC<LibraryEmptyStateProps> = ({ searchQuery }) => {
  const { beaconNavigator } = useBeaconNavigator();

  const handleGenerateContent = () => {
    beaconNavigator.updateSearchParams({
      tab: BEACON_TABS.GENERATION,
      subtab: BEACON_SUBTABS.GENERATE
    });
    beaconNavigator.go();
  };

  // If there's a search query with no results, show a simple message
  if (searchQuery) {
    return (
      <Flex
        justifyContent="center"
        marginTop="48px"
        marginBottom="48px"
        sx={{
          '& .no-data-placeholder-table-row': {
            padding: '0 !important'
          },
          '& .no-data-placeholder-table-row-title': {
            marginTop: '20px !important',
            '& .MuiTypography-root': {
              fontSize: '20px !important'
            }
          },
          '& .no-data-placeholder-table-row-description': {
            fontSize: '16px',
            fontWeight: 400,
            marginTop: '8px'
          }
        }}
      >
        <div style={{ width: '264px' }}>
          <NoDataPlaceHolderTableRow
            title="No Results"
            description={`No products found matching "${searchQuery}". Try adjusting your search.`}
          />
        </div>
      </Flex>
    );
  }

  // Default empty state with action link
  return (
    <Flex
      justifyContent="center"
      marginTop="48px"
      marginBottom="48px"
      sx={{
        '& .no-data-placeholder-table-row': {
          padding: '0 !important'
        },
        '& .no-data-placeholder-table-row-title': {
          marginTop: '20px !important',
          '& .MuiTypography-root': {
            fontSize: '20px !important'
          }
        },
        '& .no-data-placeholder-table-row-description': {
          fontSize: '16px',
          fontWeight: 400,
          marginTop: '8px'
        }
      }}
    >
      <div style={{ width: '264px' }}>
        <NoDataPlaceHolderTableRow
          title="Add Content"
          description="There are currently no products to display. All of your products with newly generated content will be available on this page."
          link={
            <Text
              variant="body2"
              link
              onClick={handleGenerateContent}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                fontWeight: 500,
                marginTop: '4px',
                fontSize: '16px'
              }}
            >
              Generate content
              <RightArrow style={{ height: '12px', width: '12px' }} />
            </Text>
          }
        />
      </div>
    </Flex>
  );
};
